import { LegendItem, MultiLineChartSeries } from '../../../../_shared/components/graphs/multi-line-chart/multi-line-chart.component';
import { getSeriesColor } from '../../../dashboard/helpers/parts-graph.helper';
import { AssetDowntimeInsights, MaintenanceInsightsResponse } from '../models/maintenance-dashboard-response.model';

const DOWNTIME_HOURS_DECIMAL_PLACES = 2;

export interface AssetDowntimeDataset {
  label: string;
  data: MaintenanceInsightsResponse[];
}

export interface AssetDowntimeChart {
  series: MultiLineChartSeries[];
  legend: LegendItem[];
  datasets: AssetDowntimeDataset[];
}

export function mapAssetDowntimeToChart(data: AssetDowntimeInsights[]): AssetDowntimeChart {
  const series = data.map((item, index) => ({
    key: getSeriesKey(index),
    color: getSeriesColor(index),
    label: item.make
  }));

  return {
    series,
    legend: series.map(s => ({ legend: s.label, color: s.color })),
    datasets: data.map((item, index) => ({
      label: getSeriesKey(index),
      data: item.data ?? []
    }))
  };
}

// Downtime comes back as fractional hours with long float tails, which would otherwise reach the tooltip and totals
export function roundDowntimeHours(hours: number): number {
  const factor = 10 ** DOWNTIME_HOURS_DECIMAL_PLACES;
  return Math.round(hours * factor) / factor;
}

// Make names can contain spaces, which break the chart's `.dot-<key>` selectors
function getSeriesKey(index: number): string {
  return `make${index}`;
}